import { getReports } from "@/services/reports.service";
import { useQuery } from "@tanstack/react-query";

export const useReports = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "reports",
    params.page,
    params.size,
    params.sort,
    params.search,
    params.type,
    params.status,
    params.createdById,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getReports(params),
    enabled,
    // Report generation is async server-side (no SSE endpoint yet to push
    // completion) - poll while any row on this page is still generating so
    // the table catches the READY/FAILED transition without a manual refresh.
    refetchInterval: (data) =>
      data?.data?.some((r) => r.status === "GENERATING") ? 5000 : false,
    ...options,
  });
};
